import React, { useEffect, useState } from "react";
import { Card, Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import "./pot-selection-retirement.scss";
import Buttons from "../../atoms/Buttons";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import { Icons } from "../../atoms/Icons";
import dayjs from "dayjs";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import LoadingSpinner from "../../atoms/Loader";
import { addCommas, formatGBP } from "../../helpers/helpers";
import { ModalOverlay } from "../../atoms/Modal";
import { useNavigate } from "react-router-dom";

const PotSelectionRetirement = (props) => {
  const { savingsFundFetching, savingsFundData } = useSelector(
    (state) => state.fundsSavings //eslint-disable-line
  );
  const { data } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );

  const { editingPage, setEditingPage } = props;
  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");
  // eslint-disable-next-line no-unused-vars
  const [totalAmount, setTotalAmount] = useState(0);
  const [enteredValue, setEnteredValue] = useState("");
  const [remainingValue, setRemainingValue] = useState(0);
  const [isValid, setIsValid] = useState(false);
  const [combiningPots, setCombiningPots] = useState(false);
  const [displayValue, setDisplayValue] = useState("");
  const [potValueList, setPotValueList] = useState({
    mostPopularPots: {
      value: "",
      isChecked: true,
    },
    individualPots: [],
  });
  const navigate = useNavigate();

  const [selectedList, setSelectedList] = useState([]);
  const [allPotsIWithZeroValue, setAllPotsIWithZeroValue] = useState(false); //eslint-disable-line

  const savingsFundsWithoutZeroPotValue =
    savingsFundData?.savingsPots?.potInfo?.filter((item) => {
      return parseFloat(item?.totalPotValue) !== 0;
    });

  useEffect(() => {
    if (savingsFundsWithoutZeroPotValue) {
      const selectedPotIds =
        data?.applicationPots?.map((pot) => Number(pot?.potId)) || [];
      let isMostPopularSelected = false;
      if (
        data?.choose?.mostPopularChecked ||
        Object.keys(data?.choose).length === 0
      ) {
        isMostPopularSelected = true;
      }
      const individualPots = savingsFundsWithoutZeroPotValue?.map(
        (item) => {
          const isPreviouslySelected = selectedPotIds.includes(item?.potId);
          return {
            potNumber: item?.potId,
            potName: item?.potName,
            value: Number(item?.totalPotValue)?.toFixed(2),
            gp3Account: item?.GP3,
            isChecked: isMostPopularSelected ? false : isPreviouslySelected,
          };
        } //eslint-disable-line
      );

      setSelectedList(individualPots.filter((pot) => pot.isChecked));
      setPotValueList({
        mostPopularPots: {
          value: savingsFundData?.savingsPots?.totalValue,
          isChecked: isMostPopularSelected,
        },
        individualPots: individualPots,
      });
    }
    if (parseFloat(savingsFundData?.savingsPots?.totalValue) === 0) {
      setAllPotsIWithZeroValue(true);
    }
  }, [savingsFundData, data]);

  const dispatch = useDispatch();
  const { getFundSavingsContent } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );

  useEffect(() => {
    if (Object.keys(savingsFundData).length === 0 && props.investorId) {
      getFundSavingsContent(props.investorId);
    }
  }, [savingsFundData, props.investorId]);

  const handleMostPopularChange = () => {
    setSelectedList([]);
    const updatedDummyValue = { ...potValueList };
    updatedDummyValue.mostPopularPots.isChecked =
      !potValueList?.mostPopularPots?.isChecked;

    if (updatedDummyValue.mostPopularPots.isChecked) {
      updatedDummyValue.individualPots.forEach((pot) => {
        pot.isChecked = false;
      });
    }
    setPotValueList(updatedDummyValue);
  };

  const handleIndividualPotChange = (index) => {
    const updatedDummyValue = { ...potValueList };
    updatedDummyValue.mostPopularPots.isChecked = false;
    updatedDummyValue.individualPots[index].isChecked =
      !updatedDummyValue.individualPots[index].isChecked;
    setPotValueList(updatedDummyValue);
  };
  const [showSelectedPots, setShowSelectedPots] = useState(false);

  //Mapping of the pots - status to potNumber
  const savingsPotInfoStatusMapping = {};
  savingsFundData?.savingsPots?.potInfo?.forEach((item) => {
    savingsPotInfoStatusMapping[item?.potId] = item?.status;
  });

  const handleChange = (e) => {
    let input = e.target.value.replace(/[£,]/g, "").trim(); // Remove £ and commas
    // Allow typing a dot but don't store it unless followed by digits

    const TWO_DECIMAL_REGEX = /^\d*\.?\d{0,2}$/;

    if (TWO_DECIMAL_REGEX.test(input) && Number(input) <= totalAmount) {
      const numericValue = Number(input);

      setDisplayValue(input);

      if (numericValue <= 0) {
        setEnteredValue("");
        setRemainingValue(totalAmount);
        setIsValid(false);
      } else {
        // Remove trailing dot if present
        const cleanValue = input.endsWith(".") ? input.slice(0, -1) : input;
        setEnteredValue(cleanValue);
        setRemainingValue(Number((totalAmount - numericValue).toFixed(2)));
        setIsValid(true);
      }
    }
  };

  return (
    <>
      {" "}
      {savingsFundFetching ? (
        <div>
          <LoadingSpinner width="60" topMargin="100" />
        </div>
      ) : (
        <Card className="application-step">
          {!showSelectedPots ? (
            <Card.Body className="p-0">
              <Row>
                <Col md={12} className="mb-fourty">
                  <p className="guidance">
                    Which pot(s) would you like to use?
                  </p>
                </Col>
              </Row>
              <div className="pot-container flex-wrap d-flex justify-content-between">
                <div className="d-flex flex-column justify-content-between">
                  <div>
                    <div
                      className={`most-popular-pot ${
                        potValueList?.mostPopularPots?.isChecked &&
                        !allPotsIWithZeroValue
                          ? "pot-bg"
                          : ""
                      } ${
                        allPotsIWithZeroValue ? "disable-most-popular-pot" : ""
                      }`}
                    >
                      <div className="most-popular">
                        <div className="most-popular-text">MOST POPULAR</div>
                      </div>
                      <CustomCheckbox
                        type="checkbox"
                        name="pot"
                        potId="default"
                        variantName="custom-checkbox text-end"
                        checked={
                          allPotsIWithZeroValue
                            ? false
                            : potValueList?.mostPopularPots?.isChecked
                        }
                        onChange={handleMostPopularChange}
                      />

                      <p className="total-value-head">Total pot</p>
                      <p className="total-value">
                        £
                        {addCommas(
                          Math.trunc(
                            parseFloat(potValueList.mostPopularPots?.value) // eslint-disable-line
                          ) // eslint-disable-line
                        )}
                        .
                        <span className="eac-pot-value-small-digit">
                          {(parseFloat(potValueList.mostPopularPots?.value) % 1)
                            .toFixed(2)
                            .substring(2)}
                        </span>
                      </p>
                    </div>
                    {potValueList?.individualPots?.length > 1 && (
                      <div className={`combining-pots mt-2`}>
                        <p className="combine-pot-head">
                          Ease of one drawdown pot in retirement
                        </p>
                        <p className="combine-pot-desc">
                          If you plan to use drawdown, please consider combining
                          your TPT pots{" "}
                          <span className="combine-pot-head">
                            before you proceed
                          </span>{" "}
                          to give you a single drawdown account in retirement.
                        </p>
                        <p
                          className="combine-pot-popup"
                          onClick={() => setCombiningPots(true)}
                        >
                          Explore combining memberships here
                        </p>
                      </div>
                    )}
                    {allPotsIWithZeroValue && (
                      <div className="error-message">
                        Please select membership(s) with a value greater than
                        £0.
                      </div>
                    )}
                  </div>
                  <div className=" m-42 d-flex align-items-center justify-content-start mt-4">
                    <div className="value-correct-date">
                      {" "}
                      Values correct as of {todayDate}
                    </div>

                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Popover
                          id="popover-contained"
                          className="tooltip-popover-section-pot-selection"
                        >
                          <Popover.Body className="tooltip-popover-body-pot-selection">
                            <p>
                              {" "}
                              All the values are estimates, based on the most
                              accurate information available. They include all
                              the contributions paid by you and your employer.
                            </p>
                            <p>
                              The value of your pension savings is based on
                              current financial conditions and is not
                              guaranteed. The amounts you receive may be higher
                              or lower than the amounts shown above. Payment of
                              your pension will be subject to TPT’s Trust Deed
                              and Rules, and regulatory requirements.
                            </p>{" "}
                          </Popover.Body>
                        </Popover>
                      }
                      flip={true}
                    >
                      <span className="textarea-tooltip">
                        <Icons iconname="tool-tip" variant="icon-twelve-px" />
                      </span>
                    </OverlayTrigger>
                  </div>
                </div>
                <div className="vertical-separator d-none d-xl-block"></div>

                <div className="individual-pot-container">
                  <p className="individual-pots">Individual pots</p>
                  {potValueList?.individualPots?.map((pot, index) => (
                    <div
                      key={index}
                      className={`individual-pot ${
                        pot.isChecked ? "pot-bg" : ""
                      }`}
                    >
                      <CustomCheckbox
                        type="checkbox"
                        name="pot"
                        potId="default"
                        variantName="custom-checkbox float-end"
                        checked={pot.isChecked}
                        onChange={() => {
                          handleIndividualPotChange(index);
                          setSelectedList([]);
                        }}
                      />

                      <p className="pot-value-id">{pot.potNumber}</p>
                      <p className="pot-value-head">{pot.potName}</p>
                      <p className="pot-total-value">
                        {savingsPotInfoStatusMapping[pot.potNumber]}
                      </p>
                      <p className="pot-total-value">
                        £{addCommas(pot?.value)}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <Row className="d-flex justify-content-between buttons mt-5">
                <Buttons
                  name="Back"
                  className="secondary"
                  handleClick={() => props.makeInitialStepper(true)}
                />
                <div className="right-buttons">
                  <Buttons
                    handleClick={() => {
                      let list = potValueList.mostPopularPots?.isChecked
                        ? potValueList?.individualPots
                        : potValueList?.individualPots.filter(
                            (item) => item?.isChecked //eslint-disable-line
                          );
                      setSelectedList(list);
                      if (list?.length > 0) {
                        let totalPotValue = 0;
                        if (list?.length == 1) {
                          totalPotValue = Number(list[0]?.value);
                        } else {
                          totalPotValue = list?.reduce((acc, curr) => {
                            return acc + Number(curr.value);
                          }, 0);
                        }
                        setTotalAmount(totalPotValue);
                        setShowSelectedPots(true);
                        setRemainingValue(totalPotValue);
                      }
                    }}
                    className="tertiary w-auto"
                    name="Take a portion"
                    disabled={allPotsIWithZeroValue}
                  />

                  <Buttons
                    name="Take all"
                    className="primary "
                    disabled={allPotsIWithZeroValue}
                    handleClick={() => {
                      setSelectedList(potValueList?.individualPots);
                      let list = potValueList.mostPopularPots?.isChecked
                        ? potValueList?.individualPots
                        : potValueList?.individualPots.filter(
                            (item) => item?.isChecked //eslint-disable-line
                          );

                      const totalCombinedPotValue = list?.reduce(
                        (acc, curr) => {
                          return acc + Number(curr.value);
                        },
                        0 //eslint-disable-line
                      );
                      let applicationPots = list?.map(
                        (item) => {
                          return {
                            potId: item.potNumber,
                            potName: item.potName,
                            potValue: item.value,
                            gp3Account: item.gp3Account,
                          };
                        } //eslint-disable-line
                      );
                      let choose = {
                        totalPotAmount: parseFloat(
                          potValueList.mostPopularPots?.value //eslint-disable-line
                        ),
                        monetaryChoice: "AMOUNT",
                        monetaryActualAmount: potValueList?.mostPopularPots
                          ?.isChecked
                          ? parseFloat(potValueList?.mostPopularPots?.value)
                          : parseFloat(totalCombinedPotValue),
                        monetaryChosenAmount: potValueList?.mostPopularPots
                          ?.isChecked
                          ? parseFloat(potValueList.mostPopularPots?.value)
                          : parseFloat(totalCombinedPotValue),
                        monetaryRemainingAmount: remainingValue?.toFixed(2),
                        mostPopularChecked:
                          potValueList?.mostPopularPots?.isChecked,
                      };
                      localStorage.setItem("choose", JSON.stringify(choose));
                      localStorage.setItem(
                        "applicationPots",
                        JSON.stringify(applicationPots) //eslint-disable-line
                      );
                      if (choose?.monetaryChosenAmount > 0) {
                        props.nextStepIndentifier(
                          RA_STEPS_IDENTIFIERS.RA_POT_SELECTION,
                          {
                            choose,
                            applicationPots,
                          },
                          "",
                          editingPage //eslint-disable-line
                        );
                        setEditingPage("");
                        props?.setIsPotSelectionCompleted(true);
                      }
                    }}
                  />
                </div>
              </Row>
              <ModalOverlay
                popup="combiningTptPots"
                show={combiningPots}
                headTitle="Combining TPT pension pots"
                description={
                  <>
                    <p>
                      If you’re thinking about income drawdown, bringing your
                      TPT pots together before you retire would give you the
                      ease of one drawdown account to manage into your
                      retirement.
                    </p>
                    <p>
                      Please ‘
                      <span
                        className="getintouch-link"
                        onClick={() => navigate("/get-in-touch/")}
                      >
                        Get in touch
                      </span>
                      ’ to request an internal transfer – use the live chat or
                      give us a call during office hours.
                    </p>
                    <p>
                      <p className="combining-tpt-pots-sub-headings">
                        Why combine your TPT pots
                      </p>
                      <ul>
                        <li>
                          Ease of retirement planning
                          <ul>
                            <li>all TPT pension savings in one place</li>
                            <li>
                              Single investment strategy and target retirement
                              age
                            </li>
                            <li>
                              One drawdown investment and income to manage in
                              retirement
                            </li>
                            <li>Simpler decision-making and documentation</li>
                          </ul>
                        </li>
                        <br />
                        <li>
                          You can still take part of your pension at a time
                          and/or partially transfer out (while in accumulation)
                        </li>
                        <li>
                          Protected pension age and/or Protected tax-free cash
                          is maintained as TPT is a single registered pension
                          scheme
                        </li>
                        <li>
                          You can choose which membership to use for your
                          combined pot, such as:
                          <ul>
                            <li>
                              your current active membership, if you are paying
                              contributions
                            </li>
                            <li>
                              membership with a lower administration charge
                              (you’d benefit from any lower admin charge on your
                              combined pot)
                            </li>
                          </ul>
                        </li>
                        <li>
                          Your combined pot will have the same investment
                          strategy and retirement age as the membership it is
                          moved to. You can change this at any time.
                        </li>
                      </ul>
                    </p>
                    <p>
                      <p className="combining-tpt-pots-sub-headings">
                        Keeping multiple TPT pots
                      </p>
                      <ul>
                        <li>
                          Separate TPT pots may feel more flexible, even if you
                          can achieve the same with one account
                        </li>
                        <li>
                          You might have retirement plans that you want to
                          maintain, e.g. different target retirement ages and/or
                          investments for separate memberships
                        </li>
                        <li>
                          Each membership would also have a separate drawdown
                          account in retirement, which cannot be combined later
                          <ul>
                            <li>
                              You can only ‘top up’ an existing drawdown account
                              by taking more pension from the same original
                              membership
                            </li>
                            <li>
                              Each drawdown account must be managed individually
                              in the future
                            </li>
                            <li>
                              You could transfer out separate drawdown pots
                              individually
                            </li>
                          </ul>
                        </li>
                        <li>
                          We would need to keep an active contributing
                          membership in place (you can’t move an active pot into
                          a previous membership)
                        </li>
                        <li>
                          Each membership has an administration charge. If you
                          keep your pots separate, any discounted administration
                          charge applies to that specific membership.
                        </li>
                      </ul>
                    </p>
                    <p className="fw-bold">
                      If you are uncertain, please seek independent guidance or
                      financial advice.
                    </p>
                    <p>
                      <p className="combining-tpt-pots-sub-headings mb-0">
                        Notes
                      </p>
                      <ul>
                        <li>
                          If you have a new TPT membership in the future but
                          before you retire, you can move a combined pot into
                          the new membership
                        </li>
                        <li>
                          Drawdown pots cannot be combined, so new memberships
                          could result in a further drawdown pot in the future
                        </li>
                        <li>
                          Pension regulations require separate drawdown accounts
                          for drawdown as a beneficiary drawdown, or transfer-in
                          of drawdown from another pension scheme.
                        </li>
                      </ul>
                    </p>
                    <p className="conclusion-para">
                      The above points relate to the combining of defined
                      contribution (DC) pension pots only. Any defined benefit
                      (DB) or ‘hybrid’ pensions would have separate
                      considerations not detailed here. If in doubt, please
                      contact us.
                    </p>
                  </>
                }
                btnCloseName="Close"
                onHide={(e) => {
                  if (e !== undefined) {
                    e.preventDefault();
                  }
                  setCombiningPots(false);
                }}
              />
            </Card.Body>
          ) : (
            <Card.Body className="p-0">
              <Row>
                <Col md={12} className="mb-fourty">
                  <p className="guidance p-0 m-0">
                    How much of your pension savings would you like to use?
                  </p>
                  <p className="description">
                    Taking a portion of your pension savings will be pro-rata
                    from your selected pot(s) and their underlying investments.
                  </p>
                </Col>
              </Row>

              <div className="selected-pots">
                <div className="selected-pots-list">
                  <p className="pot-select-title">Retiring with</p>

                  <div className="pot-box-container">
                    {selectedList?.map((item) => {
                      return (
                        <div className="pot-box m-16" key={item?.potNumber}>
                          <p className="pot-value-id">{item?.potNumber}</p>
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="pot-value-head">{item?.potName}</p>
                            <p className="pot-total-value">
                              £{addCommas(item?.value)}
                            </p>
                          </div>
                          <p className="pot-value-id fs-6">
                            {savingsPotInfoStatusMapping[item?.potNumber]}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="vertical-separator d-none d-xl-block _separator"></div>
                <div className="choose-amount">
                  <>
                    <div className="amount-form">
                      <Row>
                        <Col md={8}>
                          <p className="description m-0">
                            Enter the amount that you’d like to apply with
                          </p>
                        </Col>
                        <Col md={4} className="p-0 d-flex justify-content-end">
                          <input
                            type="text"
                            value={formatGBP(displayValue)}
                            id="amount"
                            aria-describedby="amount"
                            onChange={handleChange}
                            className="gbp-input"
                          />
                        </Col>
                      </Row>

                      <Row bsPrefix="_row">
                        <Col md={8}>
                          <p className="description m-0">
                            Amount remaining (current value):
                          </p>
                        </Col>
                        <Col md={4} className="p-0 d-flex justify-content-end">
                          <span className="amount">
                            £{addCommas(Number(remainingValue)?.toFixed(2))}
                          </span>
                        </Col>
                      </Row>
                    </div>
                    <div className=" m-42 d-flex align-items-center">
                      <div className="value-correct-date">
                        {" "}
                        Values correct as of {todayDate}
                      </div>

                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Popover
                            id="popover-contained"
                            className="tooltip-popover-section-pot-selection"
                          >
                            <Popover.Body className="tooltip-popover-body-pot-selection">
                              <p>
                                {" "}
                                All the values are estimates, based on the most
                                accurate information available. They include all
                                the contributions paid by you and your employer.
                              </p>
                              <p>
                                The value of your pension savings is based on
                                current financial conditions and is not
                                guaranteed. The amounts you receive may be
                                higher or lower than the amounts shown above.
                                Payment of your pension will be subject to TPT’s
                                Trust Deed and Rules, and regulatory
                                requirements.
                              </p>{" "}
                            </Popover.Body>
                          </Popover>
                        }
                        flip={true}
                      >
                        <span className="textarea-tooltip">
                          <Icons iconname="tool-tip" variant="icon-twelve-px" />
                        </span>
                      </OverlayTrigger>
                    </div>
                  </>
                </div>
              </div>

              <Row className="button-container pot">
                <Col md={6}>
                  {" "}
                  <Buttons
                    handleClick={() => {
                      setShowSelectedPots(false);
                      setIsValid(false);
                      setEnteredValue("");
                      setDisplayValue("");
                    }}
                    className="secondary back-btn"
                    name="Back"
                  />
                </Col>
                <Col md={6} className="text-end">
                  <Buttons
                    handleClick={() => {
                      let applicationPots = selectedList.map((item) => {
                        return {
                          potId: item.potNumber,
                          potName: item.potName,
                          potValue: item.value,
                          gp3Account: item.gp3Account,
                        };
                      });

                      let choose = {
                        totalPotAmount: potValueList.mostPopularPots?.value,
                        monetaryChoice: "AMOUNT",
                        monetaryActualAmount: totalAmount?.toFixed(2),
                        monetaryChosenAmount: enteredValue,
                        monetaryRemainingAmount: remainingValue?.toFixed(2),
                        mostPopularChecked:
                          potValueList?.mostPopularPots?.isChecked,
                      };
                      localStorage.setItem("choose", JSON.stringify(choose));
                      localStorage.setItem(
                        "applicationPots",
                        JSON.stringify(applicationPots) //eslint-disable-line
                      );
                      props.nextStepIndentifier(
                        RA_STEPS_IDENTIFIERS.RA_POT_SELECTION,
                        {
                          choose,
                          applicationPots,
                        },
                        "",
                        editingPage //eslint-disable-line
                      );
                      setEditingPage("");
                      props?.setIsPotSelectionCompleted(true);
                    }}
                    className="primary"
                    name="Continue"
                    disabled={!isValid}
                  />
                </Col>
              </Row>
            </Card.Body>
          )}
        </Card>
      )}
    </>
  );
};

export default PotSelectionRetirement;
